export type FrameSchedule = {
  fps: number;
  durationSeconds: number;
  frameCount: number;
  frameDurationSeconds: number;
};

export function createFrameSchedule(durationSeconds: number, fps: number): FrameSchedule {
  if (!Number.isFinite(durationSeconds) || durationSeconds <= 0) {
    throw new RangeError("Video duration must be a positive finite number.");
  }
  if (!Number.isFinite(fps) || fps <= 0 || fps > 240) {
    throw new RangeError("Frame rate must be between 0 and 240 fps.");
  }

  const normalizedFps = Math.round(fps * 1000) / 1000;
  const frameDurationSeconds = 1 / normalizedFps;
  const frameCount = Math.max(1, Math.ceil(durationSeconds * normalizedFps));

  return {
    fps: normalizedFps,
    durationSeconds,
    frameCount,
    frameDurationSeconds,
  };
}

export function frameTimeSeconds(schedule: FrameSchedule, frameIndex: number) {
  if (!Number.isInteger(frameIndex) || frameIndex < 0 || frameIndex >= schedule.frameCount) {
    throw new RangeError(`Frame index ${frameIndex} is outside the export schedule.`);
  }
  return Math.min(schedule.durationSeconds, frameIndex * schedule.frameDurationSeconds);
}

export function frameTimestampMicroseconds(schedule: FrameSchedule, frameIndex: number) {
  return Math.round(frameTimeSeconds(schedule, frameIndex) * 1_000_000);
}

export function frameProgress(schedule: FrameSchedule, frameIndex: number) {
  if (schedule.frameCount <= 1) return 1;
  return Math.max(0, Math.min(1, frameIndex / (schedule.frameCount - 1)));
}
